<template>
  <div>
    <div class="top-search">
      <div class="all-Search">
        <el-input
          style="width: 530px"
          size="small"
          suffix-icon="el-icon-search"
          v-model="params.keyWord"
          placeholder="请输入搜索关键字，包括发起人、审批标题、编号、正文内容"
          @change="getData(searchValue, 'search')"
        ></el-input>
        <span :class="isShowAdvanced ? 'searchBtn isConceal' : 'searchBtn'">
          <el-button
            type="primary"
            size="small"
            @click="getData(searchValue, 'search')"
          >
            搜索
          </el-button>
          <el-button type="text" @click="isShowAdvanced = true"
            >高级搜索</el-button
          >
        </span>
        <span :class="isShowAdvanced ? 'searchBtn' : 'searchBtn isConceal'">
          <el-button type="text" @click="isShowAdvanced = false">
            关闭高级搜索
          </el-button>
        </span>
      </div>
      <div
        :class="
          isShowAdvanced ? 'search-conditions' : 'search-conditions isConceal'
        "
      >
        <div class="search-condition">
          <span>提交审批时间：</span>
          <el-date-picker
            v-model="commitTime1"
            value-format="yyyy/MM/dd HH:mm:ss"
            size="small"
            type="datetime"
            placeholder="请选择"
          ></el-date-picker>
          <span style="padding-left: 10px; padding-right: 10px">~</span>
          <el-date-picker
            v-model="commitTime2"
            value-format="yyyy/MM/dd HH:mm:ss"
            size="small"
            type="datetime"
            placeholder="请选择"
          ></el-date-picker>
        </div>
        <div class="search-condition">
          <span>完成审批时间：</span>
          <el-date-picker
            v-model="performTime1"
            value-format="yyyy/MM/dd HH:mm:ss"
            size="small"
            type="datetime"
            placeholder="请选择"
          ></el-date-picker>
          <span style="padding-left: 10px; padding-right: 10px">~</span>
          <el-date-picker
            v-model="performTime2"
            value-format="yyyy/MM/dd HH:mm:ss"
            size="small"
            type="datetime"
            placeholder="请选择"
          ></el-date-picker>
        </div>
        <div class="search-condition" v-if="$route.query.type == 3">
          <span>任务处理时间：</span>
          <el-date-picker
            v-model="dealedTime1"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="small"
            type="datetime"
            placeholder="请选择"
          ></el-date-picker>
          <span style="padding-left: 10px; padding-right: 10px">~</span>
          <el-date-picker
            v-model="dealedTime2"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="small"
            type="datetime"
            placeholder="请选择"
          ></el-date-picker>
        </div>
        <div class="search-condition" style="padding-left: 10px">
          <el-button
            type="primary"
            size="small"
            @click="getData(searchValue, 'search')"
          >
            搜索
          </el-button>
          <el-button type="text" @click="clearData">清空搜索条件</el-button>
        </div>
      </div>
      <div :class="isShowAdvanced ? '' : 'isConceal'">
        <el-divider></el-divider>
      </div>
    </div>
    <div class="choose">
      <span style="padding-right: 10px; font-size: 14px">类型</span>
      <el-select
        @change="getData(searchValue, 'search')"
        v-model="params.procDefKey"
        style="width: 200px; margin-right: 10px"
        size="small"
        placeholder="点击选择类型"
        clearable
        filterable
      >
        <el-option
          v-for="item in prodefList"
          :label="item.title"
          :key="item.index"
          :value="item.index"
        >
          <span style="float: left">{{ item.title }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{
            "(" + item.count + ")"
          }}</span>
        </el-option>
      </el-select>
      <el-radio-group
        v-if="searchValue != 'getMyHandling'"
        @change="getData(searchValue, 'search')"
        size="small"
        v-model="params.taskStatus"
      >
        <el-radio-button :label="''">全部</el-radio-button>
        <el-radio-button :label="'COMMIT'">审批中</el-radio-button>
        <el-radio-button :label="'APPROVAL'">审批通过</el-radio-button>
        <el-radio-button :label="'REJECT'">审批拒绝</el-radio-button>
        <el-radio-button :label="'REVOKE'">已撤销</el-radio-button>
      </el-radio-group>
    </div>
  </div>
</template>
<script>
import bpmApi from "@/api/activityBPM/index";
import * as globalSearchApi from "../../api/globalSearch";
export default {
  props: {
    searchValue: {
      type: String,
      default: ""
    },
    size: {
      type: Number,
      default: 10
    },
    page: {
      type: Number,
      default: 1
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      prodefList: [],
      isShowAdvanced: false,
      // keyWord: '', // 搜索关键字
      commitTime1: "",
      commitTime2: "",
      dealedTime1: "",
      dealedTime2: "",
      performTime1: "",
      performTime2: "",
      // procDefKey: '',
      // taskStatus: '',
      params: {
        keyWord: "",
        taskStatus: "",
        procDefKey: "",
        serveName: "eip-mapp-oa-server"
      }
    };
  },

  mounted() {
    this.getprodefList();
  },
  methods: {
    getData(value, key) {
      if (key === "search") {
        this.page = 1;
      }
      if (
        (!this.commitTime1 && this.commitTime2) ||
        (this.commitTime1 && !this.commitTime2)
      ) {
        this.$message.warning("请输入完整的提交审批时间");
        return;
      } else if (
        (!this.performTime1 && this.performTime2) ||
        (this.performTime1 && !this.performTime2)
      ) {
        this.$message.warning("请输入完整的完成审批时间");
        return;
      } else if (
        (!this.dealedTime1 && this.dealedTime2) ||
        (this.dealedTime1 && !this.dealedTime2)
      ) {
        this.$message.warning("请输入完整的任务处理时间");
        return;
      }

      // 表格条件搜索
      this.$emit("update:loading", true);
      let timer = setTimeout(() => {
        this.$notify({
          title: "提示",
          message: "正在加载中，请勿刷新",
          type: "warning"
        });
      }, 10000);
      this.params.optionList =
        this.dealedTime1 || this.dealedTime2
          ? [
              {
                name: "handledUser.taskEndTime",
                optionType: "EQ",
                value: this.dealedTime1 + "," + this.dealedTime2
              }
            ]
          : [];
      this.params.procDefKey = this.params.procDefKey?.toLowerCase();
      globalSearchApi[value]({
        optionList: [
          this.commitTime1 || this.commitTime2
            ? {
                name: "taskCreateTime",
                optionType: "EQ",
                value: this.commitTime1 + "," + this.commitTime2
              }
            : {},
          this.performTime1 || this.performTime2
            ? {
                name: "taskEndTime",
                optionType: "EQ",
                value: this.performTime1 + "," + this.performTime2
              }
            : {}
        ],
        page: this.size * (this.page - 1),
        params: this.params,
        size: this.size
      })
        .then(res => {
          clearTimeout(timer);
          this.$emit("update:loading", false);
          let dbData = [];
          let statusQueryParams = [];
          res.data.hits.hits.forEach(item => {
            item._source["id"] = item._id;
            dbData.push(item._source);
            if (value !== "getMyStart") {
              statusQueryParams.push({
                procDefKey: item._source.mainTable,
                taskDefinitionKey: item._source.taskDefinitionKey,
                createTime: item._source.taskCreateTime
              });
            } else {
              if (item._source.processInstanceId)
                statusQueryParams.push({
                  processInstanceId: item._source.processInstanceId
                });
            }
          });
          this.$emit("update:searchData", dbData || []);
          this.$forceUpdate();
          // this.$emit('getStatus', statusQueryParams)
          this.$emit("update:totalCount", res.data.hits.total.value);
          this.$forceUpdate();
        })
        .catch(() => {
          clearTimeout(timer);
          this.$emit("update:loading", false);
        });
    },
    getprodefList() {
      //获取类型列表
      let _this = this;
      let type = this.$route.query.type;
      if (type == 2) {
        type = 3;
      } else if (type == 3) {
        type = 2;
      }
      let params = { serveName: "eip-mapp-oa-server", type: type };
      globalSearchApi.typeCountByEs(params).then(res => {
        if (res.success) {
          _this.prodefList = res.data || [];
        } else {
          if (res.code !== "0500") {
            _this.$message.error(res.msg);
          }
        }
      });
    },
    clearData() {
      this.keyWord = "";
      this.commitTime1 = "";
      this.commitTime2 = "";
      this.performTime1 = "";
      this.performTime2 = "";
      this.dealedTime1 = "";
      this.dealedTime2 = "";
      this.getData(this.searchValue);
    }
  }
};
</script>
<style lang="scss" scoped>
.top-search {
  padding-top: 10px;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 14px;
}
.searchBtn {
  padding-left: 10px;
}
.search-conditions {
  max-width: 500px;
}
.isConceal {
  display: none;
}
.search-conditions .el-date-editor.el-input {
  width: 160px;
}
.search-condition {
  padding-top: 10px;
}
.el-divider--horizontal {
  margin: 10px 0 0 0;
}
.choose {
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 20px;
}
</style>
